<div class="layout">
  <div class="slider-inner">
    <div *ngIf="slides.length &&  !loading">
      <ngx-slick-carousel class="carousel hero-slider" #slickModal="slick-carousel" [config]="slideConfig"
        (init)="slickInit($event)" (breakpoint)="breakpoint($event)" (afterChange)="afterChange($event)"
        (beforeChange)="beforeChange($event)">
        <div ngxSlickItem *ngFor="let slide of slides;let index=index" class="img-slide">
          <div class="slide-content">
            <img src="{{ slide.banner_image }}" alt="" />
            <div class="slider-custom-overlay"></div>
            <div class="slide-text-wpr">
              <div class="slide-text">
                <h2>{{slide?.text}}</h2>
              </div>
              <a class="slide-btn" href="{{slide.url}}" target="_blank" *ngIf="activeItem===index">
                <!-- <div>Explore</div> -->
                <span><i class="fa fa-arrow-right"></i></span>
              </a>
            </div>
          </div>
        </div>
      </ngx-slick-carousel>
      <ul class="slick-dots" role="tablist">
        <li class="pointer" [ngClass]="{'slick-active':activeItem===index}" role="presentation"
          *ngFor="let slide of slides;let index = index" (click)="slickModal.slickGoTo(index)">
          <button type="button" role="tab" tabindex="-1">1</button>
        </li>
      </ul>
    </div>

    <div *ngIf="!slides.length || loading">
      <div class="py-8 text-center" *ngIf="loading">
        <i style="color: #fff;font-size: 25px;" class='pi pi-spin pi-spinner'></i>
      </div>
      <div class="py-8 text-center" *ngIf="!slides.length && !loading">
        No Data Found
      </div>
    </div>
  </div>
</div>
<div class="layout who-we-are">
  <p class="who-we-are-title">Who We Are</p>
  <div class="grid m-0 who-we-content">
    <div class="who-we-content-text col-12 lg:col xl:col p-0">
      <p>Welcome to the premier destination for futsal enthusiasts in Australia! Since 2006, we have proudly
        served as the epicenter of elite, social, and junior futsal action in the country. If you're passionate about
        this
        fast-paced and exhilarating sport, you've come to the right place.</p>

      <p> Our futsal leagues are renowned for their competitiveness and the unparalleled level of skill on display.
        Whether
        you're an experienced player looking for a challenging league or a newcomer eager to embrace the excitement of
        futsal, we have something for everyone.</p>

      <p> Getting started is easy – simply click at the top of the screen and begin your futsal journey with us today.
        Join
        our vibrant community, make new friends, and experience the thrill of futsal like never before. Welcome aboard,
        and let the fun begin!</p>
    </div>
    <div class="who-we-content-img lg:col-6 xl:col-6 col-12 p-0 flex align-items-center justify-content-center">
      <img src="assets/images/Frame.png">
    </div>
  </div>
</div>
<div class="layout">
  <div class="latest-video">
    <div class="latest-video-header">
      <p class="latest-video-text">Latest Videos</p>
      <!-- <a href="">view all <span>-></span></a> -->
    </div>
    <div class="latest-video-inner">
      <div class="video-div" *ngFor="let video of videoList.data">
        <div class="video-card" (click)="showVideo(video)">
          <img src="{{video?.thumbnail}}" style="opacity: 0.5;" />
          <img src="assets/images/play.png" class="play-icon" />
        </div>
        <p class="video-text">
          {{video?.title}}
        </p>
      </div>

      <div *ngIf="!videoList.data.length || videoLoader" class="w-full">
        <div class="py-8 text-center" *ngIf="videoLoader">
          <i style="color: #fff;font-size: 25px;" class='pi pi-spin pi-spinner'></i>
        </div>
        <div class="py-8 text-center" *ngIf="!videoList.data.length && !videoLoader">
          No Data Found
        </div>
      </div>
    </div>
  </div>
</div>

<div class="layout">
  <div class="latest-photos-sec">
    <div class="photos-sec">
      <p class="latest-photos-text">Latest Photos</p>


      <div *ngIf="imageList.photos.length" class="photo-main">
        <div class="scrollableview hidden-scroll" infiniteScroll [infiniteScrollDistance]="5"
          [infiniteScrollThrottle]="500" [scrollWindow]="false" [alwaysCallback]="true" (scrolled)="photoScroll()">
          <div class="photos-sec-inner grid m-0" id="photos">
            <div class="photos-top" *ngFor="let image of imageList.photos;let index =index"
              (click)="openLightbox(index)">
              <img src="{{image?.photo_url}}" (load)="imageLoaded()">
            </div>
          </div>
        </div>
        <div class="loader text-center flex flex-column justify-content-center" *ngIf="imageLoader">
          <i style="color: #fff;font-size: 25px;" class='pi pi-spin pi-spinner'></i>
        </div>
      </div>


      <div class="photos-sec-inner" *ngIf="!imageList.photos.length">
        <div class="py-8 text-center" *ngIf="imageLoader">
          <i style="color: #fff;font-size: 25px;" class='pi pi-spin pi-spinner'></i>
        </div>
        <div class="py-8 text-center" *ngIf="!imageList.photos.length && !imageLoader">
          No Data Found
        </div>
      </div>
    </div>


  </div>
</div>

<!-- <div class="layout">
  <div class="latest-news-sec">
    <div class="latest-news-header">
      <p class="latest-news-text">latest News</p>
      <a href="">view all <span>-></span> </a>
    </div>
    <div class="latest-news-inner">
      <div class="image-div">
        <div class="image-card">
          <img src="../../../assets/images/Rectangle 20.png" alt="" />
        </div>
        <p class="image-text">
          FC Barcelona lead in Golden Boy 2022 candidates
        </p>
      </div>
      <div class="image-div">
        <div class="image-card">
          <img src="../../../assets/images/Rectangle 21.png" alt="" />
        </div>
        <p class="image-text">
          Mohamed Salah can become Liverpool’s outright leading captain
        </p>
      </div>
      <div class="image-div">
        <div class="image-card">
          <img src="../../../assets/images/Rectangle 22.png" alt="" />
        </div>
        <p class="image-text">
          Carlo Ancelotti in the running to be named UEFA Coach of Manchester
        </p>
      </div>
    </div>
  </div>
</div> -->
<p-dialog header="" [(visible)]="isShowVideo" *ngIf="isShowVideo" [style]="{width: '100%',maxWidth:'1000px' }">
  <iframe width="100%" height="500" [src]="videoUrl" frameborder="0" allowfullscreen></iframe>
</p-dialog>